import {
  checkboxColumn,
  dateColumn,
  floatColumn,
  keyColumn,
  textColumn,
} from "react-datasheet-grid";

import "./styles.css";
import { muliPopoverSelectColumn } from "@stories/atoms/SpreadSheet/MuliPopoverSelect";

import {
  SocialProcurementEntityType,
  socialProcurementEntityTypeToString,
} from "@interfaces/socialProcurement";
import {
  SocialCommitmentLineItem,
  SocialCommitmentTypeSpend,
  socialCommitmentTypeSpendToString,
} from "@interfaces/commitment";
import { selectColumn } from "@stories/atoms/SpreadSheet/SpreadSheetSelect";
import { decodeSocialProcurementEntityType } from "decoders/socialProcurement";
import { buttonColumn } from "@stories/atoms/SpreadSheet/SheetButton";
import { Country } from "country-state-city";

export const getSocialProcurementColumns = (
  projcetId: string,
  commitments: SocialCommitmentLineItem[],
  isUploading: boolean,
  setIsUploading: (toggle: boolean) => void,
  loading: boolean
) => {
  const countries = Country.getAllCountries();

  const columns = [
    {
      ...keyColumn("transactionDate", dateColumn),
      title: "Transaction Date",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...keyColumn(
        "entityType",
        selectColumn(
          {
            options: Object.values(SocialProcurementEntityType).map((e) => {
              return {
                value: e,
                label: socialProcurementEntityTypeToString(e),
              };
            }),
          },
          ({ rowData, value }) => {
            const selectedOption = Object.keys(
              SocialProcurementEntityType
            ).find((choice, index) => choice === value);
            return selectedOption
              ? socialProcurementEntityTypeToString(
                  decodeSocialProcurementEntityType(selectedOption)
                )
              : null;
          }
        )
      ),
      title: "Entity Type",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("supplier", textColumn) as any),
      title: "Supplier",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("abn", textColumn) as any),
      title: "ABN",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...keyColumn(
        "supplierCountry",
        selectColumn(
          {
            options: countries.map((c) => {
              return {
                value: c.isoCode,
                label: c.name,
              };
            }),
          },
          ({ rowData, value }) => {
            const selectedOption = Object.keys(
              SocialProcurementEntityType
            ).find((choice, index) => choice === value);
            return selectedOption
              ? socialProcurementEntityTypeToString(
                  decodeSocialProcurementEntityType(selectedOption)
                )
              : null;
          }
        )
      ),
      title: "Supplier Country",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("supplyPostCode", textColumn) as any),
      title: "Supplier Postcode",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("invoiceReference", textColumn) as any),
      title: "Invoice Reference",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("natureOfExpenditure", textColumn) as any),
      title: "Nature of Expenditure",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("invoiceValue", floatColumn) as any),
      title: "Invoice Value",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
    {
      ...(keyColumn("comments", textColumn) as any),
      title: "Comments",
      keepFocus: true,
      disableKeys: true,
      disabled: loading,
      className: "row-font",
      minWidth: 200,
    },
  ];

  for (const sc of commitments) {
    columns.push({
      ...(keyColumn(`${sc.id}`, checkboxColumn) as any),
      title:
        sc.targetDescription ||
        socialCommitmentTypeSpendToString(
          sc.targetName as SocialCommitmentTypeSpend
        ),
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
      minWidth: 200,
    });
  }

  columns.push({
    ...keyColumn(
      "copyOfInvoice",
      buttonColumn(projcetId, isUploading, setIsUploading)
    ),
    title: "",
    keepFocus: true,
    disableKeys: true,
    disabled: true,
    className: "row-font",
    minWidth: 200,
  });
  return columns;
};
